import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-primary" }, "Presentations", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "nav nav-tabs",
  id: "tab-pre",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-item nav-link active",
    id: "tab-pre-inter-oral",
    "data-bs-toggle": "tab",
    href: "#panel-pre-inter-oral",
    role: "tab",
    "aria-controls": "panel-pre-inter-oral",
    "aria-selected": "true"
  }, "International conferences (Oral)"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-item nav-link",
    id: "tab-pre-inter-poster",
    "data-bs-toggle": "tab",
    href: "#panel-pre-inter-poster",
    role: "tab",
    "aria-controls": "panel-pre-inter-poster",
    "aria-selected": "false"
  }, "International conferences (Poster)"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-item nav-link",
    id: "tab-pre-seminar",
    "data-bs-toggle": "tab",
    href: "#panel-pre-seminar",
    role: "tab",
    "aria-controls": "panel-pre-seminar",
    "aria-selected": "false"
  }, "Seminars")
], -1)
const _hoisted_5 = {
  class: "tab-content",
  id: "panel-pre"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InterOral = _resolveComponent("InterOral")!
  const _component_InterPoster = _resolveComponent("InterPoster")!
  const _component_ExtSeminar = _resolveComponent("ExtSeminar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_InterOral),
        _createVNode(_component_InterPoster),
        _createVNode(_component_ExtSeminar)
      ])
    ])
  ]))
}